module.exports = __webpack_public_path__ + "files/6711d143444036fc7aacb8084c75eec4.png";